import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Copy } from "lucide-react";

/**
 * Tells the instructor where their members sign in, with a copyable link —
 * the portal's primary discovery channel is the instructor sharing it.
 */
const MemberPortalShareCard = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const portalUrl = `${window.location.origin}/portal/login`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(portalUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="with-border rounded-2xl bg-white p-4 dark:bg-primary-10 lg:p-6">
      <h2 className="text-lg font-semibold text-grey-20 dark:text-white">
        {t("trialRequests.portalShareTitle", "Your members' portal")}
      </h2>
      <p className="mt-1 text-sm text-grey-40 dark:text-grey-80">
        {t(
          "trialRequests.portalShareIntro",
          "Members and parents sign in here with just their email (the address on their member record) and see their schedule, balance and payments. Share the link in your welcome message or chat group.",
        )}
      </p>
      <div className="mt-4 flex items-center gap-2">
        <code className="min-w-0 flex-1 truncate rounded-lg bg-grey-95 px-3 py-2 text-sm text-grey-20 dark:bg-primary-20 dark:text-white">
          {portalUrl}
        </code>
        <button type="button" className="btn btn-secondary" onClick={handleCopy}>
          <Copy size={16} />
          {copied ? t("trialRequests.copied", "Copied!") : t("trialRequests.copyLink", "Copy link")}
        </button>
      </div>
    </div>
  );
};

export default MemberPortalShareCard;
